import { rpm } from 'bmiq-common';

export const rpmSummaryData = {
  [rpm.cptCodes.CPT_SERVICE_INITIATION]: {
    thirtyDays: 1,
    yearToDate: 2,
  },
  [rpm.cptCodes.CPT_RPM_THRESHOLD_MET]: {
    thirtyDays: 1,
    yearToDate: 2,
  },
};
